/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { TextControl } from '@wordpress/components';
import { applyFilters, addFilter } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter( `gutenify--${ hookPrefix }--inspector--tabs--advance`, `gutenify--${ hookPrefix }--inspector--tabs--advance--additonal-css-classes`, ( content, props ) => {
	const { setAttributes, attributes } = props;
	const { blockAdvanceOptions } = attributes;
	return [ ...content, <Fragment key={ `gutenify--${ hookPrefix }--inspector--tabs--advance--additonal-css-classes` }>
		<Accordion tabs={ [
			{
				name: 'additional-css-classes',
				initialOpen: true,
				label: () => {
					return __( 'Additional CSS Classes' );
				},
				cb: () => {
					return <>
						<TextControl
							label={ __( 'Prefix Title Classes' ) }
							value={ blockAdvanceOptions?.prefixTitleClasses }
							onChange={ ( val ) => {
								const data = {
									blockAdvanceOptions: {
										...blockAdvanceOptions,
										prefixTitleClasses: val,
									},
								};
								setAttributes( data );
							} }
						/>
						<TextControl
							label={ __( 'Main Title Classes' ) }
							value={ blockAdvanceOptions?.mainTitleClasses }
							onChange={ ( val ) => {
								const data = {
									blockAdvanceOptions: {
										...blockAdvanceOptions,
										mainTitleClasses: val,
									},
								};
								setAttributes( data );
							} }
						/>
						<TextControl
							label={ __( 'Suffix Title Classes' ) }
							value={ blockAdvanceOptions?.suffixTitleClasses }
							onChange={ ( val ) => {
								const data = {
									blockAdvanceOptions: {
										...blockAdvanceOptions,
										suffixTitleClasses: val,
									},
								};
								setAttributes( data );
							} }
						/>
					</>;
				},
			},
		] } />
	</Fragment> ];
} );
